module.exports = __webpack_public_path__ + "static/img/417.b8313cf.png";